export const CLIENTS = {
    ONE_DANONE: 'one_danone',
    ONE_SAVENCIA: 'one_savencia',
    ONE_DOTS: 'one_dots',
    ONE_JTI: 'one_jti',
    ONE_KC: 'one_kc',
    ONE_SALESBOOK: 'one_salesbook',
    ONE_WWP: 'one_wwp',
    ONE_SP: 'one_sp',
    ONE_WTS: 'one_wts',
    ONE_MARS: 'one_mars',
    ONE_MITSUBISHI: 'one_mitsubishi',
    ONE_AURA: 'one_aura',
    ONE_LESAFFRE: 'one_lesaffre',
    ONE_PFIZER: 'one_pfizer',
    ONE_BRANCA: 'one_branca',
    ONE_AXUM: 'one_axum'
}